export default "__VITE_ASSET__F_8o7K1uLMdL2ec3XGzqDw__";